import React, { useEffect, useState } from 'react';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import SectionMessage from '@atlaskit/section-message';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';

import { InputWrapper, Text, Wrapper } from './TestingAreaStyled';

interface Props {
    regexToTest: string;
}

const TestingArea: React.FC<Props> = ({ regexToTest }) => {
    const [testValue, setTestValue] = useState('');
    const [isRegexValid, setIsRegexValid] = useState(false);

    const handleTestValueChange = (testValue: string) => {
        setTestValue(testValue);
        try {
            const regex = new RegExp(regexToTest);
            setIsRegexValid(regex.test(testValue));
        } catch (e) {
            setIsRegexValid(false);
        }
    };

    useEffect(() => {
        handleTestValueChange(testValue);
    }, [regexToTest]);

    return (
        <Wrapper>
            <SectionMessage
                title='Testing area'
                appearance='information'
                testId='testing-area-section-message'
            >
                <Text>Enter an example value to check if it meets the regex configured above.</Text>
                <InputWrapper>
                    <Textfield
                        testId='testing-area-input'
                        value={testValue}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleTestValueChange(e.target.value)}
                    />
                    <div>
                        {regexToTest && testValue.length >= 1 ?
                            <>
                                {isRegexValid ?
                                    <CheckCircleIcon
                                        primaryColor={token('color.text.accent.green')}
                                        label='regex valid'
                                    />
                                :   <CrossCircleIcon
                                        primaryColor={token('color.text.accent.red')}
                                        label='regex invalid'
                                    />
                                }
                            </>
                        :   null}
                    </div>
                </InputWrapper>
            </SectionMessage>
        </Wrapper>
    );
};

export default TestingArea;
